import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CTASection from '../components/sections/CTASection';
import SocialProof from '../components/sections/SocialProof';

const tasksItems = [
  'Máte připravit hodinu na zítřek?',
  'Vytvořit pracovní list?',
  'Upravit text pro slabší žáky?',
  'Připravit otázky do testu?',
  'Napsat mail rodičům?',
];

const helpItems = [
  'přípravě výuky',
  'tvorbě materiálů',
  'hledání nápadů',
  'diferenciaci úkolů',
  'formulaci zadání',
  'hodnocení',
  'administrativě',
];

const criticalItems = [
  'kdy AI nevěřit',
  'jak kontrolovat výstupy',
  'co do AI nepatří',
  'kde může pomoci a kde už začíná problém',
];

const takeItems = [
  'pracovní list',
  'osnovu hodiny',
  'návrh testu',
  'upravené zadání pro různé úrovně žáků',
  'návrh komunikace rodičům',
  'další materiály použitelné ve výuce',
];

export default function ProUcastnikyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>

        {/* Hero */}
        <section className="pt-36 pb-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inline-flex items-center px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-8">
              Financovatelné z OP JAK II
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 leading-tight mb-8">
              Žádná inspirace.<br />
              <span className="text-teal-600">Jen věci, které druhý den použijete.</span>
            </h1>
            <div className="space-y-3 text-xl text-slate-600 max-w-2xl">
              <p>Nebudete poslouchat cizí příklady.</p>
              <p className="font-semibold text-slate-800">Budete pracovat na vlastních.</p>
            </div>
          </div>
        </section>

        {/* Úkoly přímo na školení */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
              <div className="space-y-3 mb-8">
                {tasksItems.map((t, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-slate-300 flex-shrink-0" />
                    <p className="text-lg text-slate-600">{t}</p>
                  </div>
                ))}
              </div>
              <div className="border-l-4 border-teal-500 pl-6 py-2">
                <p className="text-xl font-bold text-slate-900">Uděláte to přímo během školení.</p>
                <p className="text-lg text-teal-700 font-medium mt-1">S AI a pod vedením lektora.</p>
              </div>
            </div>
          </div>
        </section>

        {/* AI jako pomocník */}
        <section className="py-16 bg-white border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-6">AI jako pomocník — ne náhrada učitele</p>
            <p className="text-lg text-slate-600 mb-8 max-w-2xl">
              Ukážeme vám, jak může AI pomoci například při:
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-w-2xl mb-12">
              {helpItems.map((item, i) => (
                <div key={i} className="flex items-center gap-2 bg-slate-50 rounded-lg px-4 py-3 border border-slate-200">
                  <div className="w-2 h-2 rounded-full bg-teal-500 flex-shrink-0" />
                  <span className="text-slate-700 text-sm">{item}</span>
                </div>
              ))}
            </div>

            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-6">Současně si ukážeme i druhou stranu</p>
            <div className="space-y-3 max-w-lg mb-8">
              {criticalItems.map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-slate-400 flex-shrink-0" />
                  <span className="text-slate-600">{item}</span>
                </div>
              ))}
            </div>
            <div className="max-w-xl space-y-2">
              <p className="text-slate-500">Ne proto, abyste se AI báli.</p>
              <p className="text-lg font-semibold text-slate-900">Ale proto, abyste ji uměli řídit.</p>
            </div>
          </div>
        </section>

        {/* Co si odnesou */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-6">Co si účastníci odnesou</p>
            <p className="text-xl text-slate-700 font-medium mb-3 max-w-2xl">Ze školení si neodnesete jen tipy.</p>
            <p className="text-lg text-slate-600 mb-8 max-w-2xl">Odnesete si konkrétní věci vytvořené během školení:</p>
            <div className="grid sm:grid-cols-2 gap-3 max-w-xl mb-8">
              {takeItems.map((item, i) => (
                <div key={i} className="flex items-center gap-3 bg-white rounded-lg px-4 py-3 border border-slate-200">
                  <div className="w-2 h-2 rounded-full bg-teal-600 flex-shrink-0" />
                  <span className="text-slate-700">{item}</span>
                </div>
              ))}
            </div>
            <p className="text-lg font-semibold text-teal-700">Věci, které můžete použít hned druhý den.</p>
          </div>
        </section>

        <SocialProof />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
